import { defineMessages } from 'react-intl';
import { useCssHandles } from '../../../utils/functions';
import { seller } from '../../mock';
import IOMessageWithMarkers from '../../native-types/IOMessageWithMarkers';

const CSS_HANDLES = ['sellerNameContainer', 'sellerName'];

const messages = defineMessages({
	title: {
		id: 'admin/seller-name.title',
	},
	description: {
		id: 'admin/seller-name.description',
	},
	default: {
		id: 'store/seller-name.default',
	},
});
function ProductSellerName({ message = messages.default.id, markers = [], blockClass, componentId }) {
	const { handles, withModifiers } = useCssHandles(
		`vtex-product-price-1-x`,
		CSS_HANDLES,
		blockClass,
		seller.sellerDefault ? 'isDefaultSeller' : '',
	);

	if (!seller) {
		return null;
	}
	const containerClasses = withModifiers('sellerNameContainer', seller.sellerDefault ? 'isDefaultSeller' : '');
	return (
		<span data-selection={componentId} className={containerClasses}>
			<IOMessageWithMarkers
				message={message}
				markers={markers}
				blockClass={blockClass}
				handleBase="sellerName"
				values={{
					sellerName: (
						<span key="sellerName" className={handles.sellerName}>
							{seller.sellerName}
						</span>
					),
				}}
			/>
		</span>
	);
}

export default ProductSellerName;
